<div class="ap-why">
    <i class="ph-bold ph-sparkle icon-ai-purple icon-16 ap-why-sparkle" aria-hidden="true"></i>
    <p class="ap-why-body">{{ section.body }}</p>
</div>
